<template>
    <div class="pt-3">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto form-inline">
                <date-picker v-model="search.date"
                             placeholder="วันที่การจอง"
                             :format="changeFormat"
                             @change="filter()"
                             :lang="lang">
                </date-picker>
                &nbsp
                <multiselect
                    v-model="search.product_type"
                    class="form-control border-0"
                    :options="optionProductType"
                    track-by="id"
                    :show-labels="false"
                    :custom-label="LabelName"
                    @input="filter()"
                    placeholder="เลือกประเภทสินค้า">
                </multiselect>
                &nbsp
                <multiselect
                    v-if="canView()"
                    v-model="search.sale"
                    class="form-control border-0"
                    :options="seller"
                    :customLabel="saleLabel"
                    placeholder="กรุณาเลือกเซลล์"
                    :show-labels="false"
                    @input="filter()"
                    track-by="sale_id">
                </multiselect>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered" style="text-align: center">
                <thead>
                <tr>
                    <th scope="col">ลำดับที่</th>
                    <th scope="col">รหัสสินค้า</th>
                    <th scope="col">วันที่จองโควต้า</th>
                    <th scope="col">จำนวนสินค้าที่จอง</th>
                    <th scope="col">เซล</th>
                    <th scope="col">วันที่อัพเดท</th>
                    <th scope="col" v-if="canView()">แก้ไข</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(x,i) in list">
                    <td>{{ i + 1 }}</td>
                    <td>{{ x.product.sku + '' + x.product.name }}</td>
                    <td>{{ x.date | moment('DD/MM/YYYY') }}</td>
                    <td>{{ x.amount }}</td>
                    <td>{{ x.sale ? x.sale.sale_id + ' - ' + x.sale.name : '' }}</td>
                    <td>{{ x.created_at | moment('DD/MM/YYYY HH:mm:ss') }}</td>
                    <td v-if="canView()">
                        <a @click="showQuotaModal(i)">
                            <icon name="pencil-alt"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status" @submit="hideLoadingModal"></loading>
        </b-modal>
        <b-modal size="l" hide-header hide-footer ref="quota_modal">
            <h4 class="text-center">จองโควต้า</h4>
            <div class="row form-group">
                <div class="col-4 text-right">
                    <label>วันที่จอง</label>
                </div>
                <div class="col-6">
                    <date-picker v-model="quota.date"
                                 placeholder="วันที่จอง"
                                 :format="changeFormat"
                                 :lang="lang">
                    </date-picker>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-4 text-right">
                    <label>รหัสสินค้า</label>
                </div>
                <div class="col-6">
                    <multiselect
                        v-model="quota.product"
                        :options="optionProducts"
                        track-by="id"
                        :show-labels="false"
                        :custom-label="LabelName"
                        placeholder="รหัสสินค้า">
                    </multiselect>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-4 text-right">
                    <label>จำนวนที่จอง</label>
                </div>
                <div class="col-6">
                    <input type="number" placeholder="0.00" v-model="quota.amount" class="form-control"/>
                </div>
            </div>
            <div class="col text-center">
                <button class="btn btn-success" @click="submit">บันทึก</button>&nbsp;
                <button class="btn btn-outline-secondary" @click="hideQuotaModal">ยกเลิก</button>&nbsp;
            </div>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";

import {canSaleView, canViewSuperAdmin} from "../../util/Permissions";

import Loading from "../Utility/Loading";
import moment from "moment/moment";
import DatePicker from "vue2-datepicker";
import BillingModal from "@/components/Accounting/Billing/BillingModal.vue";

export default {
    name: "quota-sale-list",
    components: {
        BillingModal,
        Loading,
        Multiselect,
        DatePicker
    },
    data() {
        return {
            msg: 'กำลังโหลดข้อมูล',
            status: 1,
            list: [],
            search: {
                date: '',
                product_type: '',
                sale: ''
            },
            quota: {
                id: '',
                date: new Date,
                amount: 0,
                product: '',
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    created() {
        if (canSaleView() && !canViewSuperAdmin()) {
            this.index({page: 1, sale: this.seller.filter(x => (x.id == this.user.id))[0].id});
            // this.search.sale = this.seller.filter(x => (x.id == this.user.id))[0]
        }
        // this.index({page: 1});
        this.$store.dispatch("ProductType/get");
        this.$store.dispatch("Seller/get");
    },
    computed: {
        canViewSuperAdmin,
        canSaleView,
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            optionProducts: (state) => {
                return state.Products.product_all
            },
            seller: state => {
                return state.Seller.data;
            },
            optionProductType: state => {
                return state.ProductType.data;
            },
        })
    },
    methods: {
        canView() {
            let qc = ['10223', '10228', '10701', '20648', '20701', '20726', '20729', '20655', '20708', '20683']
            let admin = ['20533']
            return (qc.includes(this.user.username) || admin.includes(this.user.username) || canViewSuperAdmin())
        },
        filter() {
            this.showLoadingModal();
            this.msg = 'กำลังโหลดข้อมูล'
            this.status = 1;
            this.index({
                page: 1,
                date: this.search.date ? this.search.date : '',
                product_type: this.search.product_type,
                sale: this.search.sale ? this.search.sale.id : ''
            })
        },
        LabelName(option) {
            return `${option.type_code} - ${option.name}`
        },
        saleLabel(option) {
            return `${option.sale_id} - ${option.name}`
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        showQuotaModal(i) {
            this.quota = {
                id: this.list[i].id,
                date: this.list[i].date,
                amount: this.list[i].amount,
                product: this.list[i].product,
            }
            this.$refs.quota_modal.show();
        },
        hideQuotaModal() {
            this.$refs.quota_modal.hide();
        },
        index(data) {
            let payload = {
                page: data.page,
                view_all: this.canView(),
                // view_all: true,
                sale_id: data.sale ? data.sale : '',
                date: data.date ? moment(data.date).format('YYYY-MM-DD') : '',
                product_type: data.product_type ? data.product_type.id : ''
            }
            this.$store.dispatch('Products/indexQuota', payload).then(res => {
                this.list = res.data
                this.hideLoadingModal()
            })
        },
        submit() {
            this.msg = 'กำลังบันทึกข้อมูล'
            this.status = 1
            this.showLoadingModal()
            if (this.quota.product && this.quota.product && this.quota.amount != 0) {
                this.quota.date = this.quota.date ? moment(this.quota.date).format('YYYY-MM-DD') : null;
                this.quota.product = this.quota.product ? this.quota.product.id : null;
                let data = {
                    id: this.quota.id,
                    date: this.quota.date,
                    product_id: this.quota.product,
                    sale_id: this.quota.sale_id,
                    amount: this.quota.amount,
                    is_admin: true
                }
                this.quota = {
                    id: '',
                    date: new Date,
                    amount: 0,
                    product: '',
                }
                this.$store.dispatch('Products/createQuota', data).then(() => {
                    this.msg = 'กำลังโหลดข้อมูล'
                    this.hideQuotaModal();
                    this.index({page: 1});
                })
            } else {
                this.msg = 'กรุณาใส่ข้อมูลให้ครบถ้วน';
                this.status = 3;
                this.showLoadingModal();
            }
        }
    },
}
</script>

<style lang="scss" scoped>
</style>
